import { render, staticRenderFns } from "./payorder.vue?vue&type=template&id=a5128baa&scoped=true"
import script from "./payorder.vue?vue&type=script&lang=js"
export * from "./payorder.vue?vue&type=script&lang=js"
import style0 from "./payorder.vue?vue&type=style&index=0&id=a5128baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5128baa",
  null
  
)

export default component.exports